var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderTypeDocuments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 11C9.5 9.067 11.067 7.5 13 7.5H19C20.933 7.5 22.5 9.067 22.5 11V16.8889C22.5 17.165 22.2761 17.3889 22 17.3889C21.7239 17.3889 21.5 17.165 21.5 16.8889V11C21.5 9.61929 20.3807 8.5 19 8.5H13C11.6193 8.5 10.5 9.61929 10.5 11V21C10.5 22.3807 11.6193 23.5 13 23.5H16C16.2761 23.5 16.5 23.7239 16.5 24C16.5 24.2761 16.2761 24.5 16 24.5H13C11.067 24.5 9.5 22.933 9.5 21V11Z",
    fill: "#12181E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 12C12.25 11.5858 12.5858 11.25 13 11.25H19C19.4142 11.25 19.75 11.5858 19.75 12C19.75 12.4142 19.4142 12.75 19 12.75H13C12.5858 12.75 12.25 12.4142 12.25 12Z",
    fill: "#12181E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 15C12.25 14.5858 12.5858 14.25 13 14.25H17C17.4142 14.25 17.75 14.5858 17.75 15C17.75 15.4142 17.4142 15.75 17 15.75H13C12.5858 15.75 12.25 15.4142 12.25 15Z",
    fill: "#12181E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 18C12.25 17.5858 12.5858 17.25 13 17.25H14C14.4142 17.25 14.75 17.5858 14.75 18C14.75 18.4142 14.4142 18.75 14 18.75H13C12.5858 18.75 12.25 18.4142 12.25 18Z",
    fill: "#12181E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2803 19.2197C23.5732 19.5126 23.5732 19.9874 23.2803 20.2803L19.9571 23.6036C19.5666 23.9941 18.9334 23.9941 18.5429 23.6036L17.2197 22.2803C16.9268 21.9874 16.9268 21.5126 17.2197 21.2197C17.5126 20.9268 17.9874 20.9268 18.2803 21.2197L19.25 22.1893L22.2197 19.2197C22.5126 18.9268 22.9874 18.9268 23.2803 19.2197Z",
    fill: "#12181E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderTypeDocuments);
export default __webpack_public_path__ + "static/media/order_type_documents.97c0cd70cabb46f3f5b9216b755ad4c6.svg";
export { ForwardRef as ReactComponent };